import { CodePay } from './code-pay';
import { ListItem } from '../../../shared/list-confirmation/model/list-item';

export class PaymentFederalTaxes {
	typeTax: string;

	originAgencyCode: number;
	originAccountCode: number;

	complement: string;
	codePay: string;
	competenceMonth: number;
	competenceYear: number;
	identifierType: number;
	identifier: string;
	taxpayerName: string;
	valueINSS: number;
	valueOthers: number;
	valueCharges: number;
	valueCollection: number;

	payID: number;

	message: String = '';
	success: Boolean = false;
	confirmList: Array<ListItem> = [];

	codePayObject: CodePay;

	date: Date;
	dateLabel: string;

	password: string;

	name: string;
	cpfcnpj: string;
	refDate: Date;
	expDate: Date;
	recipeCod: string;
	recipeCodDescription: string;
	refNumber: string;
	valueDefault: string;
	valueTax: number;
	valueTicket: number;
	valueTotal: number;

	dateType: string;

	constructor() {}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/payment-federal-taxes/models/payment-federal-taxes.ts